import React, { useState } from "react";
import Sidebar from "../common/Sidebar";
import Header from "./Header";
import NavBar from "./NavBar";
import Footer from "./Footer";
import { useLocation } from "react-router";
import FloatingButton from "../common/FloatingButton";
import { Drawer } from "@mui/material";
import "../styles/sidebar.css";

const Layout = ({ children }) => {
  const router = useLocation();
  const [sidebarVisible, setSidebarVisible] = useState(false);

  const toggleSidebar = () => {
    setSidebarVisible(!sidebarVisible);
  };

  return (
    <>
      <div
        className="d-flex flex-column"
        style={{ height: "100vh", overflow: "hidden" }}
      >
        <div
          className="row flex-grow-1 w-100"
          style={{ display: "flex", flexWrap: "nowrap" }}
        >
          <div
            className="sidebar col-2 d-flex flex-column d-none d-xl-flex "
            style={{ padding: "15px 17px 5px", width: "250px" }}
          >
            <Sidebar />
          </div>
          <div
            className="col d-flex flex-column flex-grow-1"
            style={{
              paddingRight: "0px",
              paddingLeft: "20px",
              backgroundColor: "#f5f7fa",
              minWidth: 0,
              overflow: "hidden",
            }}
          >
            <nav>
              <NavBar toggleSidebar={toggleSidebar} />
            </nav>
            <div className="mt-3"></div>
            <Header
              extClass="px-20px mt-1"
              heading={
                <>
                  {router.pathname
                    .replace("/", "")
                    .split("/")
                    .map((part, index) => {
                      const formattedPart = part
                        .replaceAll("-", " ")
                        .replace(/^\w/, (c) => c.toUpperCase());
                      return index === 0
                        ? formattedPart
                        : ` / ${formattedPart}`;
                    })
                    .join("")}
                </>
              }
            />{" "}
            <div
              className={`container-fluid p-1 ${
                ![
                  "/dashboard",
                  "/profile",
                  "/classification-map",
                  "/campaign-map",
                  "/pages-list/sections",
                  "/menus-board",
                  "/control-settings-board",
                ].includes(router.pathname)
                  ? "bg-light shadow"
                  : ""
              }`}
              style={{
                flexGrow: 1,
                overflowY: "auto",
                maxHeight: "calc(100vh - 120px)",
              }}
            >
              {/* <FloatingButton /> */}
              <div
                style={{
                  width: "100%",
                  overflowX: "auto",
                  whiteSpace: "nowrap",
                }}
              >
                {children}
              </div>
            </div>
            <footer className="mt-4">
              <Footer />
            </footer>
          </div>
        </div>

        <Drawer
          anchor="left"
          open={sidebarVisible}
          onClose={toggleSidebar}
          className="d-xl-none"
        >
          <div
            className="sidebar text-white d-flex flex-column p-2"
            style={{ width: "230px" }}
          >
            <Sidebar />
          </div>
        </Drawer>
      </div>
    </>
  );
};

export default Layout;
